export * from './repeat.component';
